<form [formGroup]="addOrganizationForm" (ngSubmit)="addOrganization()">
  <div class="row">
    <div class="form-group col-md-4">
      <label>Name <span class="text-danger small">(required)</span></label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addOrganizationForm, 'name')"
             formControlName="name" placeholder="Name" required>
    </div>
    <div class="form-group col-md-4">
      <label>Website <span class="text-danger small">(required)</span></label>
      <input type="url" class="form-control" [ngClass]="setClassInvalid(addOrganizationForm, 'website')"
             formControlName="website" [pattern]="urlRegexp" placeholder="https://example.com" required>
    </div>
    <div class="form-group col-md-4">
      <label class="me-1">Stakeholders:</label>
      <input type="hidden" class="form-control" formControlName="_politicians">
      <app-search-input model="politician"></app-search-input>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12">
      <label>Notes</label>
      <textarea class="form-control" rows="5" [ngClass]="setClassInvalid(addOrganizationForm, 'notes')"
                formControlName="notes" placeholder="Notes"></textarea>
    </div>
  </div>
  <div formGroupName="socials" class="row">
    <div formGroupName="twitter" class="form-group col-md-3">
      <label>X <span class="text-danger small">(required for logo retrival)</span></label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addOrganizationForm, 'socials.twitter.username')"
             formControlName="username" placeholder="mario_rossi">
    </div>
    <div formGroupName="instagram" class="form-group col-md-3">
      <label>Instagram</label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addOrganizationForm, 'socials.instagram.username')"
             formControlName="username" placeholder="mario.rossi">
    </div>
    <div formGroupName="facebook" class="form-group col-md-3">
      <label>Facebook</label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addOrganizationForm, 'socials.facebook.username')"
             formControlName="username" placeholder="MarioRossiOfficial">
    </div>
    <div formGroupName="linkedin" class="form-group col-md-3">
      <label>LinkedIn</label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addOrganizationForm, 'socials.linkedin.username')"
             formControlName="username" placeholder="mario-rossi">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12">
      <button class="btn btn-primary" type="submit" [disabled]="!addOrganizationForm.valid">
        <i class="fa fa-plus-circle"></i> Add third party
      </button>
    </div>
  </div>
</form>